import { atom } from "recoil";
import { UserInfo } from "../api/auth";

export const UserState = atom<UserInfo | null>({
  key: "user",
  default: null,
});
